export default __webpack_public_path__ + "static/media/Regular.10194357.woff";